import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/shared/PageHero";

export default function Privacidade() {
  return (
    <Layout>
      <PageHero
        title="Política de Privacidade"
        subtitle="Última atualização: [Data]"
        variant="gradient"
      />

      <section className="section-padding section-alt">
        <div className="container-narrow">
          <div className="bg-background rounded-xl sm:rounded-2xl border border-border p-5 sm:p-8 md:p-12 shadow-lg">
            <div className="prose prose-sm sm:prose-base lg:prose-lg max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground">
              <h2>1. Introdução</h2>
              <p>
                A Cogni ("nós", "nosso" ou "Cogni") está comprometida em proteger a privacidade 
                dos usuários de nossos serviços. Esta Política de Privacidade descreve como 
                coletamos, usamos, armazenamos e protegemos suas informações pessoais.
              </p>

              <h2>2. Informações que coletamos</h2>
              <p>Podemos coletar os seguintes tipos de informações:</p>
              <ul>
                <li><strong>Informações de cadastro:</strong> nome, e-mail, telefone, empresa, cargo</li>
                <li><strong>Informações de uso:</strong> dados de navegação, interações com a plataforma</li>
                <li><strong>Informações de negócio:</strong> dados de usinas, UCs, faturas e transações</li>
                <li><strong>Informações técnicas:</strong> endereço IP, tipo de navegador, dispositivo</li>
              </ul>

              <h2>3. Como usamos suas informações</h2>
              <p>Utilizamos suas informações para:</p>
              <ul>
                <li>Fornecer e melhorar nossos serviços</li>
                <li>Processar transações e enviar notificações relacionadas</li>
                <li>Responder a solicitações de suporte</li>
                <li>Enviar comunicações de marketing (com seu consentimento)</li>
                <li>Cumprir obrigações legais e regulatórias</li>
              </ul>

              <h2>4. Compartilhamento de informações</h2>
              <p>
                Não vendemos suas informações pessoais. Podemos compartilhar dados com:
              </p>
              <ul>
                <li>Prestadores de serviço que nos auxiliam na operação (hospedagem, pagamentos, etc.)</li>
                <li>Parceiros de integração quando você autoriza conexões com outros sistemas</li>
                <li>Autoridades legais quando exigido por lei</li>
              </ul>

              <h2>5. Segurança dos dados</h2>
              <p>
                Implementamos medidas técnicas e organizacionais para proteger suas informações, 
                incluindo criptografia, controles de acesso e monitoramento contínuo.
              </p>

              <h2>6. Seus direitos (LGPD)</h2>
              <p>
                De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:
              </p>
              <ul>
                <li>Confirmar a existência de tratamento de dados</li>
                <li>Acessar seus dados pessoais</li>
                <li>Corrigir dados incompletos, inexatos ou desatualizados</li>
                <li>Solicitar anonimização, bloqueio ou eliminação de dados</li>
                <li>Solicitar portabilidade dos dados</li>
                <li>Revogar consentimento</li>
              </ul>

              <h2>7. Retenção de dados</h2>
              <p>
                Mantemos seus dados pelo tempo necessário para fornecer os serviços contratados 
                ou conforme exigido por lei. Após o término do contrato, dados são retidos por 
                [período] para fins legais e depois excluídos.
              </p>

              <h2>8. Cookies</h2>
              <p>
                Utilizamos cookies para melhorar a experiência de navegação. Você pode 
                configurar seu navegador para recusar cookies, mas isso pode afetar 
                algumas funcionalidades do site.
              </p>

              <h2>9. Alterações nesta política</h2>
              <p>
                Podemos atualizar esta política periodicamente. Notificaremos sobre 
                alterações significativas por e-mail ou através de aviso em nosso site.
              </p>

              <h2>10. Contato</h2>
              <p>
                Para exercer seus direitos ou esclarecer dúvidas sobre esta política, 
                entre em contato com nosso Encarregado de Proteção de Dados (DPO):
              </p>
              <p>
                <strong>E-mail:</strong> privacidade@cogni.com.br<br />
                <strong>Endereço:</strong> [Endereço completo]
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
